import { ItemEstoque } from '../@types/item-estoque';
import aqilaApi from './aqila-api';

class Adubos {
  private readonly endpoint = '/v1/adubos';

  async list(propriedadeId: number) {
    const params = {
      noPaginate: true,
      propriedade: propriedadeId,
    };

    const response = await aqilaApi.get<{
      data: { id: string; type: string; attributes: ItemEstoque }[];
    }>(this.endpoint, {
      params,
    });

    return response.data.data.map(({ attributes }) => attributes);
  }
}

export default new Adubos();
